import { Anchor, Group, Paper, Stack, Text } from '@mantine/core';

import { PublicationCardIdentifiers } from '@/module/Author/Publication/components/PublicationCardIdentifiers';
import { ImportItem } from '@/module/Sync/model/SyncTypes';

import { TitleCard } from '@/core/components';

import { JournalVolume, NoOfAuthors, PublishedAtText } from '@feature/utils';

import classes from './ImportCard.module.css';

export interface ImportCardProps {
  item: ImportItem;
}

export function ImportCard({ item }: ImportCardProps) {
  const {
    publishedAt,
    authors,
    journal,
    journalName,
    publisher,
    publisherName,
    startPage,
    endPage,
    noOfPages,
    identifiers,
    title,
    volume,
    volumeNo,
    link,
  } = item;

  const journalTitle = journal?.title ?? journalName;
  const publisherTitle = publisher?.title ?? publisherName;

  return (
    <Paper
      className={classes.card}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="xs">
        <TitleCard title={title} />
        <Group>
          {journalTitle && <Text>{journalTitle}</Text>}
          {publisherTitle && <Text>{publisherTitle}</Text>}
          <JournalVolume
            volume={volume}
            volumeNo={volumeNo}
            noOfPages={noOfPages}
            endPage={endPage}
            startPage={startPage}
          />
        </Group>
        <Group>
          <PublishedAtText
            date={publishedAt}
            size="sm"
            c="dimmed"
          />
          {authors && <NoOfAuthors authors={authors} />}
        </Group>
        <Group>
          <PublicationCardIdentifiers identifiers={identifiers} />
        </Group>
        {link && (
          <Anchor
            underline="always"
            href={link}
            target="_blank"
          >
            {link}
          </Anchor>
        )}
      </Stack>
    </Paper>
  );
}
